<template>
  <div>
    <v-card>
      <v-card-title>
        Kullanıcı Hareketleri
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-divider style="margin-top: 0px;margin-bottom: 0px;"></v-divider>
      <v-data-table
        dense
        height="400px"
        :headers="headers"
        :items="logs"
        :search="search"
        :page.sync="page"
        hide-default-footer
        :items-per-page="paginationObj.pageSize"
        no-data-text="KAYDINIZ BULUNMAMAKTADIR.."
        no-results-text="Aradığınız Kriterlerde Sonuç Bulunamadı."
      >
      <template v-for="header in headers" v-slot:[`item.${header.value}`]="{item}">
        <div :key="header.value" :class="header.class">
          <slot v-if="header.dataType =='date'">{{ new Date(item[header.value]).toLocaleString().split(" ")[0] }}</slot>
          <slot v-else-if="header.dataType =='currency'">{{ currencyFormatProcessing(item[header.value] ,2,3,",",".") }}</slot>
          <slot v-else-if="header.switchValue">{{ header.switchValue[item[header.value]] }}</slot>
          <slot v-else>{{item[header.value]}}</slot>
        </div>
      </template>
      </v-data-table>
      <div class="text-center">
        <v-container justify="center">
          <v-row justify="center">
            <v-col cols="8">
              <v-pagination
                v-model="paginationObj.page"
                :length="paginationObj.pagesCount"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
    <Loader></Loader>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
import Loader from "./loader";
//import Enums from "../../tools/Enums.js";
export default {
  components: { Loader },
  props: ["user", "company", "popUpStatus"],
  data() {
    return {
      page: 4,
      paginationObj: {
        page: 1,
        pagesCount: 0,
        itemCount: 0,
        pageSize: 150,
        filters: {}
      },
      search: "",
      headers: [
        { text: "id", value: "id",  width: "100px", align: "center", sortable: false, divider: true,},
        { text: "Tarih", value: "date", width: "150px",align: "center", sortable: true, dataType: "date", divider: true },
        { text: "İşlem", value: "path", align: "center", width: "250" , sortable: false, divider: true },
        { text: "Ortam", value: "userAgent", align: "center", sortable: false, class: 'threedot', divider: true },
      ],
      logs:[],
    };
  },
  created () {
    console.log("this.user")
    console.log(this.user)
    this.loadLogs(this.company)
  },
  watch: {
    popUpStatus () {
      this.loadLogs(this.company)
    },
    "paginationObj.page": function() {
      this.loadLogs(this.company);
    },
  },
  methods: {
    loadLogs(companyId) {
      this.$store.commit("LOADER", true);
      let choice ="tAppLog" , selection = null , paginationObj = this.paginationObj, type = undefined
      userReq.getUserLog(choice, selection, paginationObj, type, companyId, this.user.id).then(res => {
      console.log(res.data)
      for (let i = 0; i < res.data.data.value.length; i++) {
        res.data.data.value[i].date = res.data.data.value[i].content.date
        res.data.data.value[i].path = res.data.data.value[i].content.path
        res.data.data.value[i].userAgent = res.data.data.value[i].content.headers.userAgent
      }
      this.logs = res.data.data.value
      if (res.data.data.resultCount != 0) {
        this.paginationObj.pagesCount = Math.ceil(parseFloat(res.data.data.count) / res.data.data.resultCount)
      }else{
        this.paginationObj.pagesCount = 0
      }
      
      this.$store.commit("LOADER", false);
    }).catch(err => console.log(err))
    }
  }
};
</script>

<style scoped>
::v-deep .threedot {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
}
::v-deep .threedot:hover {
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}
</style>
